// 常量路由
export const constantRoutes = [
  {
    path: "/",
    redirect: "/home",
    meta: {
      hidden: true,
    },
  },
  {
    path: "/login",
    meta: {
      hidden: true,
    },
    component: () => import("@/views/login/index"),
  },
  {
    path: "/home",
    name: "Home",
    meta: {
      icon: "el-icon-s-home",
      name: "首页",
      affix: true,
    },
    component: () => import("../views/home/index.vue"),
  },
];

// 任意路由
export const anyRoutes = [
  //
];

// 动态路由
export const asyncRoutes = () => [
  {
    path: "/member",
    name: "Member",
    redirect: "/member/member-list",
    component: () => import("@/views/member/index.vue"),
    meta: {
      name: "用户管理",
      icon: "el-icon-user-solid",
    },
    children: [
      {
        path: "/member/member-list",
        name: "MemberList",
        component: () => import("@/views/member/member-list/list.vue"),
        meta: {
          name: "用户列表",
          keepAlive: true,
        },
      },
      {
        path: "/member/black-list",
        name: "MemberBlackList",
        component: () => import("@/views/member/black-list/list.vue"),
        meta: { name: "黑名单列表", keepAlive: true },
      },
      {
        path: "/member/white-list",
        name: "MemberWhiteList",
        component: () => import("@/views/member/white-list/list.vue"),
        meta: { name: "白名单列表", keepAlive: true },
      },
    ],
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("@/views/order/index.vue"),
    meta: { name: "订单管理", icon: "el-icon-s-order" },
    children: [
      {
        path: "/order/store-order-list",
        name: "StoreOrderList",
        component: () => import("@/views/order/order-list/store-order-list.vue"),
        meta: { name: "门店订单", keepAlive: true },
      },
      {
        path: "/order/mall-order-list",
        name: "MallOrderList",
        component: () => import("@/views/order/order-list/mall-order-list.vue"),
        meta: { name: "商城订单", keepAlive: true },
      },
      {
        path: "/order/detail/:id?",
        name: "OrderDetail",
        component: () => import("@/views/order/order-list/detail.vue"),
        meta: {
          name: "订单详情",
          hidden: true,
          keepAlive: true,
          activeMenu: "/order/order-list",
        },
      },
      {
        path: "/order/delivery/:id?",
        name: "OrderDelivery",
        component: () => import("@/views/order/order-list/delivery.vue"),
        meta: { name: "发货", hidden: true, activeMenu: "/order/order-list" },
      },
      // {
      //   path: "/order/delivery_store/:id?",
      //   name: "OrderDeliveryPick",
      //   component: () => import("@/views/order/order-list/delivery-pick.vue"),
      //   meta: {
      //     name: "门店自提",
      //     hidden: true,
      //     activeMenu: "/order/order-list",
      //   },
      // },
      {
        path: "/order/order-bill/:id?",
        name: "OrderBill",
        component: () => import("@/views/order/order-list/bill.vue"),
        meta: { name: "账单", hidden: true, activeMenu: "/order/order-list" },
      },
      {
        path: "/order/order-list/update-goods/:id?",
        name: "OrderUpdateGoods",
        component: () => import("@/views/order/order-list/modules/update-goods.vue"),
        meta: {
          name: "修改商品",
          hidden: true,
          activeMenu: "/order/order-list",
        },
      },
      {
        path: "/order/bill-list",
        name: "OrderBillList",
        component: () => import("@/views/order/bill-list/list.vue"),
        meta: { name: "账单列表", keepAlive: true },
      },
    ],
  },
  {
    path: "/review",
    name: "Review",
    component: () => import("@/views/review/index.vue"),
    meta: { name: "审核管理", icon: "el-icon-s-platform" },
    children: [
      {
        path: "/review/order-list",
        name: "ReviewOrderList",
        component: () => import("@/views/review/order-list/list.vue"),
        meta: { name: "订单列表" },
      },
      {
        path: "/review/order-detail/:id?",
        name: "ReviewOrderDetail",
        component: () => import("@/views/review/order-list/detail.vue"),
        meta: {
          name: "审核详情",
          hidden: true,
          keepAlive: true,
          activeMenu: "/review/order-list",
        },
      },
      {
        path: "/review/update-goods/:id?",
        name: "ReviewUpdateGoods",
        component: () => import("@/views/review/order-list/modules/update-goods.vue"),
        meta: {
          name: "修改商品",
          hidden: true,
          activeMenu: "/review/order-list",
        },
      },
      {
        path: "/review/assign/list",
        name: "ReviewAssignList",
        component: () => import("@/views/review/assign-list/list.vue"),
        meta: { name: "领单明细", keepAlive: true },
      },
      // {
      //   path: "/review/rule/list",
      //   name: "ReviewRuleList",
      //   component: () => import("@/views/review/review-rule/list.vue"),
      //   meta: { name: "规则配置", keepAlive: true },
      // },
      // {
      //   path: "/review/rule/add",
      //   name: "ReviewRuleAdd",
      //   component: () => import("@/views/review/review-rule/add-edit.vue"),
      //   meta: {
      //     name: "新增规则",
      //     hidden: true,
      //     activeMenu: "/review/rule/list",
      //   },
      // },
      // {
      //   path: "/review/rule/edit/:id?",
      //   name: "ReviewRuleEdit",
      //   component: () => import("@/views/review/review-rule/add-edit.vue"),
      //   meta: {
      //     name: "编辑规则",
      //     hidden: true,
      //     activeMenu: "/review/rule/list",
      //   },
      // },
      // {
      //   path: "/review/rule/detail/:id?",
      //   name: "ReviewRuleDetail",
      //   component: () => import("@/views/review/review-rule/detail.vue"),
      //   meta: {
      //     name: "规则详情",
      //     hidden: true,
      //     activeMenu: "/review/rule/list",
      //   },
      // },
    ],
  },
  {
    path: "/finance",
    name: "Finance",
    component: () => import("@/views/finance/index.vue"),
    meta: { name: "财务管理", icon: "el-icon-coin" },
    children: [
      {
        path: "/finance/bill",
        name: "FinanceBill",
        component: () => import("@/views/finance/bill/list.vue"),
        meta: { name: "流水明细" },
      },
      {
        path: "/finance/order",
        name: "FinanceOrder",
        component: () => import("@/views/finance/order/list.vue"),
        meta: { name: "订单账务" },
      },
      {
        path: "/finance/store/settle",
        name: "FinanceStoreSettle",
        component: () => import("@/views/finance/store/settle/list.vue"),
        meta: { name: "门店结算" },
      },
    ],
  },
  {
    path: "/store",
    name: "Store",
    component: () => import("@/views/store/index.vue"),
    meta: { name: "门店管理", icon: "el-icon-shopping-cart-2" },
    children: [
      {
        path: "/store/list",
        name: "StoreList",
        component: () => import("@/views/store/store-list/list.vue"),
        meta: { name: "门店列表" },
      },
      {
        path: "/store/combo/list",
        name: "StoreComboList",
        component: () => import("@/views/store/combo/list.vue"),
        meta: { name: "方案列表" },
      },
      {
        path: "/store/calculate",
        name: "StoreCalculate",
        component: () => import("@/views/store/calculate/index.vue"),
        meta: { name: "方案计算器" },
      },
      {
        path: "/store/goods/attr/list",
        name: "StoreGoodsAttrList",
        component: () => import("@/views/store/goods-attr/list.vue"),
        meta: { name: "商品属性" },
      },
      {
        path: "/store/goods/list",
        name: "StoreGoodsList",
        component: () => import("@/views/store/goods/list.vue"),
        meta: { name: "商品列表" },
      },
    ],
  },
  {
    path: "/mall",
    name: "Mall",
    redirect: "/mall/goods/list",
    meta: {
      icon: "el-icon-s-goods",
      name: "商城管理",
    },
    component: () => import("@/views/mall/index.vue"),
    children: [
      {
        path: "/mall/goods/list",
        name: "MallGoodsList",
        component: () => import("@/views/mall/goods-list/list.vue"),
        meta: {
          name: "商品列表",
          keepAlive: true,
        },
      },
      {
        path: "/mall/goods/add",
        name: "MallGoodsAdd",
        component: () => import("@/views/mall/goods-list/add-edit.vue"),
        meta: {
          name: "创建商品",
          hidden: true,
          keepAlive: false,
          activeMenu: "/goods/list",
        },
      },
      {
        path: "/mall/goods/edit/:id?",
        name: "MallGoodsEdit",
        component: () => import("@/views/mall/goods-list/add-edit.vue"),
        meta: {
          name: "编辑商品",
          hidden: true,
          keepAlive: false,
          activeMenu: "/goods/list",
        },
      },
      {
        path: "/mall/goods/category/list",
        name: "MallGoodsCategory",
        component: () => import("@/views/mall/goods-category/list.vue"),
        meta: {
          name: "商品分类",
        },
      },
    ],
  },
  {
    path: "/merchant",
    name: "Merchant",
    redirect: "/merchant/merchant-list",
    component: () => import("@/views/merchant/index.vue"),
    meta: { name: "商户管理", icon: "el-icon-s-shop" },
    children: [
      {
        path: "/merchant/merchant-list",
        name: "MerchantList",
        component: () => import("@/views/merchant/merchant-list/list.vue"),
        meta: { name: "商户列表" },
      },
    ],
  },
  {
    path: "/capital",
    name: "Capital",
    component: () => import("@/views/capital/index.vue"),
    meta: { name: "资方管理", icon: "el-icon-s-custom" },
    children: [
      {
        path: "/capital/capital-list/list",
        name: "CapitalList",
        component: () => import("@/views/capital/capital-list/list.vue"),
        meta: { name: "资方列表" },
      },
      {
        path: "/capital/order-list/list",
        name: "CapitalOrderList",
        component: () => import("@/views/capital/order-list/list.vue"),
        meta: { name: "订单列表" },
      },
      {
        path: "/capital/capital-bill/list",
        name: "CapitalBillList",
        component: () => import("@/views/capital/capital-bill/list.vue"),
        meta: { name: "流水明细" },
      },
      {
        path: "/capital/capital-withdraw/list",
        name: "CapitalWithdrawList",
        component: () => import("@/views/capital/capital-withdraw/list.vue"),
        meta: { name: "提现列表" },
      },
    ],
  },
  {
    path: "/oprt",
    name: "Operation",
    component: () => import("@/views/oprt/index.vue"),
    meta: { name: "运营管理", icon: "el-icon-s-finance" },
    children: [
      {
        path: "/oprt/ad/list",
        name: "OprtAdList",
        component: () => import("@/views/oprt/ad/list.vue"),
        meta: { name: "广告设置" },
      },
      {
        path: "/oprt/brand/list",
        name: "OprtBrandList",
        component: () => import("@/views/oprt/brand/list.vue"),
        meta: { name: "品牌设置" },
      },
      {
        path: "/oprt/document/list",
        name: "OprtDocumentList",
        component: () => import("@/views/oprt/document/list.vue"),
        meta: { name: "文案设置" },
      },
      {
        path: "/oprt/protocol/list",
        name: "OprtProtocolList",
        component: () => import("@/views/oprt/protocol/list.vue"),
        meta: { name: "协议设置" },
      },
    ],
  },
  {
    path: "/system",
    name: "System",
    redirect: "/system/user/list",
    component: () => import("@/views/system/index.vue"),
    meta: { name: "系统管理", icon: "el-icon-setting" },
    children: [
      {
        path: "/system/user/list",
        name: "SystemUserList",
        component: () => import("@/views/system/user/list.vue"),
        meta: { name: "员工管理" },
      },
      {
        path: "/system/role/list",
        name: "SystemRoleList",
        component: () => import("@/views/system/role/list.vue"),
        meta: { name: "角色管理" },
      },
      {
        path: "/system/menu/list",
        name: "SystemMenuList",
        component: () => import("@/views/system/menu/list.vue"),
        meta: { name: "菜单管理" },
      },
      {
        path: "/system/dept/list",
        name: "SystemDeptList",
        component: () => import("@/views/system/dept/list.vue"),
        meta: { name: "部门管理" },
      },
    ],
  },
];
